import React, {useState, useRef, useEffect} from 'react';
import {Layout, Flex} from 'antd';
import SiderPage from './SiderPage';
import {Routes, Route, Outlet} from 'react-router-dom';
import ContentPage from './ContentPage';
import ContentServer from './ContentServer';
import ContentModelAI from './ContentModelAI';
import './DownloadHomeStyle.css';
import useFirework from 'react-use-firework';

const {Header, Footer, Sider, Content} = Layout;
const headerStyle = {
  textAlign: 'center',
  color: '#fff',
  height: 64,
  paddingInline: 48,
  lineHeight: '64px',
  backgroundColor: '#4096ff',
};
const contentStyle = {
  textAlign: 'center',
  minHeight: 16,
  lineHeight: '120px',
  color: '#fff',
  backgroundColor: '#0958d9',
};
const siderStyle = {
  color: '#fff',
  background: 'transparent',
};
const footerStyle = {
  textAlign: 'center',
  color: '#fff',
  backgroundColor: '#4096ff',
};
const layoutStyle = {
  borderRadius: 8,
  overflow: 'hidden',
  position: 'relative',
  zIndex: 1000,
  background: '#fff',
};

const DownloadHome = () => {
  const [pathAbsolute, setPathAbsolute] = useState(null);
  const ref = useRef(null);
  const containerRef = useRef(null);

  useFirework(ref, {colors: ['red', 'yellow', 'white', 'pink', 'orange', 'violet']});

  return (
    <div className='container-all' ref={ref}>
      {/* <div
        ref={containerRef}
        class='fireworks-example'
        style={{width: '25%', position: 'fixed', zIndex: 0, background: '', height: '100%'}}
      ></div> */}
      <Layout style={layoutStyle}>
        <Sider width='25%' style={siderStyle}>
          <SiderPage setPathAbsolute={setPathAbsolute} />
        </Sider>
        <Routes>
          <Route path='/' element={<Outlet />}>
            <Route
              path='client/:path'
              element={
                <ContentPage pathAbsolute={pathAbsolute} style={contentStyle} type={'beta'} />
              }
            ></Route>
            <Route
              path='server/:path'
              element={<ContentServer pathAbsolute={pathAbsolute} style={contentStyle} />}
            ></Route>

            <Route
              path='test/:path'
              element={
                <ContentPage pathAbsolute={pathAbsolute} style={contentStyle} type={'alpha'} />
              }
            ></Route>

            <Route
              path='model/:path'
              element={<ContentModelAI pathAbsolute={pathAbsolute} style={contentStyle} />}
            ></Route>
          </Route>
        </Routes>

        {/* <Layout>
          <Header style={headerStyle}>Header</Header>
          <Footer style={footerStyle}>Footer</Footer>
        </Layout> */}
      </Layout>
    </div>
  );
};

export default DownloadHome;
